// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { connect } from 'react-redux';


function TriageNotification({ items, currentUser, openRightPane }) {
  const activeItems = _.filter(items, { status: 'Active' });
  const currentUserClaimedItems = _.filter(activeItems, (item) => item.claimedBy && item.claimedBy.id === currentUser.id);
  const unclaimedItems = _.filter(activeItems, (item) => item.claimedBy && item.claimedBy.id === undefined);
  const userRegisteredForFCM = currentUser.fcmKey !== null;

  // Don't show the alert if there are no items requiring the current user's attention
  if (!currentUserClaimedItems.length && !unclaimedItems.length && userRegisteredForFCM) return null;
  // Don't show the alert if the current user is not on call
  if (!currentUser.onCall) return null;

  return (
    <div
      id="triage-notification"
      className={classNames({ danger: unclaimedItems.length || !userRegisteredForFCM })}
      onClick={() => openRightPane('triage')}
    >
      { !userRegisteredForFCM &&
        <p>You are not registered to receive triage notifications on your phone!</p>
      }
      { unclaimedItems.length > 0 &&
        <p>{unclaimedItems.length} unclaimed triage {unclaimedItems.length > 1 ? 'items' : 'item'}</p>
      }
      { currentUserClaimedItems.length > 0 &&
        <p>{currentUserClaimedItems.length} claimed triage {currentUserClaimedItems.length > 1 ? 'items' : 'item'}</p>
      }
    </div>
  );
}

TriageNotification.propTypes = {
  items: PropTypes.array,
  currentUser: PropTypes.object.isRequired,
  openRightPane: PropTypes.func.isRequired
};

// Exports
export default connect((state) => ({
  items: state.triage.items,
  currentUser: state.auth.currentUser
}))(TriageNotification);



// WEBPACK FOOTER //
// ./app/components/widgets/triage-notification/triage-notification.js